import { ApiError, fetchWithAuth } from "@entities/user-tokens";

import type { PresignedPost, Source } from "../Source";

/** 受領データを register し、presigned POST 情報を取得する（実体は未アップロード）。 */
export async function registerSource(
    projectId: string,
    meta: { filename: string; contentType: string; size: number }
): Promise<{ source: Source; upload: PresignedPost }> {
    const res = await fetchWithAuth("/sources", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ projectId, ...meta }),
    });
    if (!res.ok) throw await ApiError.fromResponse(res, "受領データの登録に失敗しました");
    return (await res.json()) as { source: Source; upload: PresignedPost };
}
